<template>
    <portal to="modals">
        <transition name="modal">
            <div 
                v-if="value" 
                ref="modal" 
                class="modal-mask" 
                role="dialog">
                <div class="modal-mask-background" @click="close()" />
                <div :class="[size]" class="modal-wrapper">
                    <modal-inner @close="close()">
                        <slot />
                    </modal-inner>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>
import ModalInner from './ModalInner'
export default {
    name: 'modal',
    components: { ModalInner },
    props: {
        size: String,
        value: {
            type: Boolean,
            required: true
        },
        shouldFocus: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.value) {
            document.body.classList.add('modal-open')
            if (this.shouldFocus) {
                this.$refs.modal.focus()
            }
        }
    },
    beforeDestroy() {
        document.body.classList.remove('modal-open')
    },
    methods: {
        close() {
            document.body.classList.remove('modal-open')
            this.$emit('input', false)
        }
    },
    watch: {
        value: function(newValue, oldValue) {
            if (oldValue != newValue && newValue) {
                document.body.classList.add('modal-open')
            } 
            else {
                document.body.classList.remove('modal-open')
            }
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.modal-open
    overflow: hidden

.modal-mask
    position: fixed
    z-index: 999
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.5)
    display: flex
    align-items: center
    justify-content: center
    transition: opacity 0.2s ease

.modal-mask-background
    width: 100%
    height: 100%
    position: absolute
    z-index: 0
    left: 0px
    top: 0px

.modal-wrapper
    position: relative
    z-index: 10
    max-height: 97%
    border-radius: 12px
    width: 100%
    max-width: 600px
    overflow-y: scroll
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.12)

.modal-container
    max-width: 600px
    width: 100%
    margin: 0px auto
    background-color: #fff
    border-radius: 12px
    transition: all 0.2s ease
    min-height: 100%
    max-height: 800px
    overflow-y: scroll

    @media screen and (max-width: 480px)
        max-height: 500px
        height: 100%

.modal-wrapper.small
    max-width: 400px

.modal-wrapper.large
    max-width: 960px

.modal-wrapper.small .modal-container
    max-width: 400px

.modal-wrapper.large .modal-container
    max-width: 960px
    width: 100%
    height: 100%
    max-height: 600px

.modal-enter
    opacity: 0

.modal-leave-active
    opacity: 0

.modal-enter-active .modal-wrapper, .modal-leave-active .modal-wrapper
    overflow-y: visible

.modal-enter .modal-container, .modal-leave-active .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
</style>
